import { ApiClient } from './api-client';
import type { ApiResponse } from '../types';

export interface AdminUserSummary {
  id: string;
  email: string;
  displayName: string;
  firstName: string | null;
  lastName: string | null;
  phoneNumber: string | null;
  status: string | null;
  roles: string[];
  isProvider: boolean;
  providerId: string | null;
  providerBusinessName: string | null;
  createdAt: string | null;
  lastLoginAt: string | null;
}

export interface AdminUsersQuery {
  q?: string;
  page?: number;
  size?: number;
}

export const adminUsersService = {
  list: (params: AdminUsersQuery = {}): Promise<ApiResponse<AdminUserSummary[]>> =>
    ApiClient.get<AdminUserSummary[], AdminUsersQuery>('/admin/users', {
      q: params.q ?? '',
      page: params.page ?? 0,
      size: params.size ?? 50,
    }),

  /**
   * Step 1 — request a 6-digit email confirmation code. The code is sent
   * to the SUPER_ADMIN's mailbox and is required by {@link remove}.
   */
  requestDelete: async (id: string): Promise<void> => {
    await ApiClient.post<void>(`/admin/users/${id}/delete-request`);
  },

  /**
   * Step 2 — soft-delete the user, supplying the code received by email.
   * SUPER_ADMIN-only on the backend; the code is single-use, 10 min TTL.
   */
  remove: async (id: string, code: string): Promise<void> => {
    await ApiClient.delete(`/admin/users/${id}`, { code });
  },
};
